import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'bxl-exhibit-video-modal',
  templateUrl: 'exhibit-video-modal.component.html',
})
export class ExhibitVideoModalComponent implements OnInit {
  initialized = false;

  @Input()
  url: string;


  youtubeUrl: SafeUrl;
  vimeoUrl: SafeUrl;

  constructor(public actieveModal: NgbActiveModal, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    let url1 = 'https://youtu.be/';
    let url2 = 'https://www.youtube.com/watch?v=';
    let url3 = 'https://vimeo.com/';

    let index = this.url.indexOf(url1);
    if (index > -1) {
      let youtubeVideoId = this.url.slice(index + url1.length);
      this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + youtubeVideoId + '?autoplay=1');
    }

    index = this.url.indexOf(url2);
    if (index > -1) {
      let youtubeVideoId = this.url.slice(index + url2.length);
      this.youtubeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + youtubeVideoId + '?autoplay=1');
    }

    index = this.url.indexOf(url3);
    if (index > -1) {
      let vimeoId = this.url.slice(index + url3.length);
      this.vimeoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + vimeoId +  '?autoplay=1');
    }


    this.initialized = true;
  }


}
